import * as actionTypes from '../actions/types.js';

export default (state = { formData: {}, appSettings: {}, staffSettings: [], companySettings: {} }, action) => {
 

    switch (action.type) {

        case actionTypes.SETTING_ADD:
            return {
                ...state,
                formData: { ...action.payload }
            };

        case actionTypes.MOBILE_APP_SETTING:
            return {
                ...state,
                appSettings: { ...action.payload }
            };
            
        case actionTypes.STAFF_SETTINGS:
            return {
                ...state,
                staffSettings:  [...action.payload ]
            };
            
            case actionTypes.Company_Settings:
            return {
                ...state,
                companySettings:  {...action.payload }
            };   

        default:
            return state;
    }
};
